export default "__VITE_ASSET__lyPK8T_v__"